import type { TimelineLabelI } from "tweenly"
import { filterTimelineLabelsByTime } from "../store/slices/timeline.slice"
import { useAppSelector } from "./useRedux"

/**
 * Subscribed access to the timeline labels.
 *
 * Split out of `useTimelineActions` so that hook can stop subscribing altogether: it is
 * instantiated in every TimelineRow, every TimeStamp and — through `useObjectActions` — in
 * every CanvasItem and AbstractContainer, while `labelsInTimeStamp` is read during render by
 * TimeStamp alone.
 */
export const useTimelineLabels = () => {
    const timeline = useAppSelector((state) => state.timeline.value)

    const labelsInTimeStamp = (from: number, to: number): TimelineLabelI[] =>
        filterTimelineLabelsByTime(timeline, from, to).sort(
            (a: TimelineLabelI, b: TimelineLabelI) => a.time - b.time
        )

    return { labelsInTimeStamp }
}
